import { InputBase } from "components/Atoms/formInputs/InputBase";
import { useValidate } from "formvalidation/hooks";
import React, { useRef } from "react";
import { useCustomQuery } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";

interface FreeFieldReferenceInputProps {
  validatorKey: string
  mainArea: server.dto.MainAreas
  excludeKey?: number
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
}

export const FreeFieldReferenceInput = (props: FreeFieldReferenceInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const freeFieldReferenceValidator = useCustomQuery({
    queryKey: ["freeFieldReferenceValidator", props.value],
    queryFn: () => window.CoreApi.FreeFieldDefinition.ReferenceExists({
      mainArea: props.mainArea,
      excludeId: props.excludeKey,
      reference: props.value
    }).then(r => r.data),
    enabled: false,
  });

  const validateReference = async (): Promise<string | boolean> => {
    if (props.value.length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    const referenceExists = await freeFieldReferenceValidator.refetch();
    if (referenceExists.data.data) {
      return RESX.FreeField.ThisReferenceCodeHasAlreadyBeenUsedForAnotherFreeField;
    }

    return true;
  }

  const validation = useValidate({
    key: props.validatorKey,
    title: RESX.FreeField.ReferenceCode,
    value: props.value,
    validate: validateReference,
    ref: inputRef,
    type: "manual"
  });

  return <InputBase
    ref={inputRef}
    maxLength={serverReference.constants.freeFieldDefinition.maxReferenceLength}
    value={props.value}
    onChange={value => { props.onChange(value); }}
    error={validation.error.errorMessage}
    loading={freeFieldReferenceValidator.isFetching}
    onBlur={props.onBlur}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    rightComponent={{ position: "right", type: "text", label: "FF" }}
  />
}